import {Dialog, Typography} from '@mui/material';
import AnimatedProgreesBar from '../aur-pizza-traker-progress/component/AnimatedProgressBar';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import AurButton from '../aur-button/AurButton';
import {t} from 'i18next';

interface AurEcaValidationLoaderProps {
  isOpen: boolean;
  keepMounted: boolean;
  onClose: (value?: string) => void;
}

const AurEcaValidationLoader: React.FC<AurEcaValidationLoaderProps> = ({
  isOpen,
  onClose,
  ...other
}) => {
  const IconComponent = <SearchOutlinedIcon className="search-color" />;

  return (
    <div data-testid="eca-search-loader">
      <Dialog
        fullScreen={true}
        open={isOpen}
        PaperProps={{className: 'overlay'}}
        {...other}
      >
        <div className="eca-search-loader-main">
          <div className="pulse-icon-container">
            <div className="pulse-outer-container">
              <div className="pulse"></div>
              <div className="container">{IconComponent}</div>
            </div>
            <AnimatedProgreesBar status={'Processing'} width={156} />
            <div className="empty-space-container"></div>
          </div>
          <div className="title-container">
            {
              <Typography className="typo-text headline2_size head-text">
                {t(`common.aurEcaValidationLoader.heading1`)}
              </Typography>
            }
            {
              <Typography className="typo-text body2_size sub-head-text">
                {t(`common.aurEcaValidationLoader.subHeading1`)}
              </Typography>
            }
          </div>
          <div className="title-container">
            <AurButton
              type="text"
              label={t('common.aurEcaValidationLoader.cancelBtn')}
              title={t('common.aurEcaValidationLoader.cancelBtn')}
              size="Medium"
              onClick={() => onClose('cancel')}
              dataTestId='cancel-button'
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AurEcaValidationLoader;
